const onlyNumbers = (input: string | number) => {
  return String(input).replace(/[^\d]/g, '')
}

const isLastChar = (index: number, input: string) => {
  return index === input.length - 1
}

export { onlyNumbers, isLastChar }
